import * as React from "react";

import {useSandboxURL} from "./use-sandbox-url.ts";

type IFrameRefType = HTMLIFrameElement | null;

/**
 * A component that renders an iframe that evaluates Python code and renders
 * its output.
 */
const PythonOutputFrame = React.forwardRef<IFrameRefType>((_, ref) => {
    const sandboxURL = useSandboxURL("python");
    return (
        // eslint-disable-next-line jsx-a11y/iframe-has-title -- TODO: Address a11y error
        <iframe
            ref={ref}
            src={sandboxURL}
            style={{width: "100%", height: "100%"}}
        />
    );
});

export default PythonOutputFrame;
